import { SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';

export abstract class ImageLoaderProvider {
  abstract getImage(imageKey: string, customerId: string | undefined): Observable<SafeUrl>;
}
